import { Image, Avatar, Box, BoxProps } from '@chakra-ui/react';
import React, { memo } from 'react';
import { Marker } from 'react-map-gl';

import './EndLocationMarker.scss';

interface IUserDetails {
  user_id: number;
  first_name: string;
  last_name: string;
  photo_url?: string;
}

interface IEndLocationMarkerProps {
  latitude: number;
  longitude: number;
  userDetail: IUserDetails;
  markerBoxProps?: BoxProps;
  handleMarkerClick: (userId: number, longitude: number, latitude: number) => void;
}

const EndLocationMarker: React.FC<IEndLocationMarkerProps> = ({
  handleMarkerClick,
  latitude,
  longitude,
  userDetail,
  markerBoxProps,
}) => {
  return (
    <Marker latitude={latitude} longitude={longitude} offset={[0, -25]}>
      <Box
        className="marker-background"
        p="1"
        height="58.15px"
        width="48px"
        display="flex"
        justifyContent="center"
        onClick={() => {
          handleMarkerClick(userDetail.user_id, longitude, latitude);
        }}
        cursor="pointer"
        {...markerBoxProps}
      >
        <Image
          boxSize="32px"
          objectFit="cover"
          fallback={
            <Avatar
              name={userDetail.first_name + ' ' + userDetail.last_name}
              boxSize="32px"
              borderRadius="50%"
              sx={{ '& div': { fontSize: 'md' } }}
            />
          }
          borderRadius="50%"
          src={userDetail?.photo_url}
          alt={userDetail.first_name}
        />
      </Box>
    </Marker>
  );
};

export default memo(EndLocationMarker);
